import {
  SkeletonAvatar,
  SkeletonCheckbox,
  SkeletonTable,
  SkeletonText,
} from '@dev-spendesk/grapes';
import React from 'react';

const LOADER_ROWS = 3;

export const AccountPayableSuppliersSubListLoader = () => {
  return (
    <SkeletonTable
      className="ml-24 h-fit flex-[1_0_368px]"
      numberOfRows={LOADER_ROWS}
      withHeader
      columns={[
        {
          cell: (
            <div className="flex w-full items-center gap-8">
              <SkeletonCheckbox className="mr-8" />
              <SkeletonAvatar size="m" variant="square" />
              <SkeletonText size="l" width="60%" />
            </div>
          ),
          header: <SkeletonText size="l" width="60%" />,
        },
      ]}
    />
  );
};
